import { Link } from "react-router-dom";
import { popularSpaces } from "../../../mocks/inspirations";

export default function PopularSpaces() {
  return (
    <section className="py-28 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-16">
          <div>
            <p
              className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Most Loved
            </p>
            <h2
              className="text-[#2C2825] text-4xl md:text-5xl"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
            >
              Popular Calm Spaces
            </h2>
          </div>
          <p
            className="text-[#8B8378] text-sm leading-relaxed max-w-xs"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            The most-loved interiors from the journal.
          </p>
        </div>

        {/* Asymmetric Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {/* Large Feature Card */}
          <div className="md:col-span-7 group relative overflow-hidden rounded-xl bg-[#EDE6DA] cursor-pointer">
            <div className="aspect-[16/11] overflow-hidden">
              <img
                src={popularSpaces[0].image}
                alt={popularSpaces[0].title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-104"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <span
                className="text-white/65 text-[10px] tracking-widest uppercase block mb-2"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {popularSpaces[0].category}
              </span>
              <h3
                className="text-white text-2xl md:text-3xl leading-snug group-hover:text-[#EDE6DA] transition-colors"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {popularSpaces[0].title}
              </h3>
            </div>
          </div>

          {/* Right Column — 2 stacked cards */}
          <div className="md:col-span-5 flex flex-col gap-5">
            {popularSpaces.slice(1, 3).map((post) => (
              <div
                key={post.id}
                className="group relative overflow-hidden rounded-xl bg-[#EDE6DA] cursor-pointer flex-1"
              >
                <div className="aspect-[4/3] md:aspect-auto md:h-full overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span
                    className="text-white/60 text-[10px] tracking-widest uppercase block mb-1.5"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {post.category}
                  </span>
                  <h3
                    className="text-white text-lg leading-snug group-hover:text-[#EDE6DA] transition-colors"
                    style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
                  >
                    {post.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom Row — 3 equal cards */}
          {popularSpaces.slice(3, 6).map((post) => (
            <div
              key={post.id}
              className="md:col-span-4 group relative overflow-hidden rounded-xl bg-[#EDE6DA] cursor-pointer"
            >
              <div className="aspect-[5/4] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span
                  className="text-white/60 text-[9px] tracking-widest uppercase block mb-1"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {post.category}
                </span>
                <h3
                  className="text-white text-base leading-snug group-hover:text-[#EDE6DA] transition-colors"
                  style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
                >
                  {post.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/cozy-corners"
            className="inline-flex items-center gap-2.5 bg-[#2C2825] text-[#FAF7F0] px-10 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Browse Popular Posts
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
